export default __webpack_public_path__ + "static/media/logout-icon.352f1d01.svg";